import * as Sentry from '@sentry/react'
import { config } from '@/shared/config'

/**
 * Инициализация Sentry на фронтенде.
 *
 * Вызывается из main.tsx до рендера. Пустой DSN — штатная ситуация (local):
 * SDK просто не поднимается, никаких заглушек и проверок в коде приложения
 * не требуется.
 */
export function initSentry(): void {
  if (!config.sentry.dsn) {
    return
  }

  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    // Пустая строка сломала бы группировку по релизам, поэтому undefined.
    release: config.sentry.release || undefined,
    tracesSampleRate: config.sentry.tracesSampleRate,

    // События уходят не в ingest Sentry, а на наш API.
    //
    // Две причины: запросы к домену Sentry режут блокировщики рекламы, и часть
    // ошибок просто не доезжает; плюс не нужно ничего согласовывать по CORS.
    // Бэкенд (SentryTunnelController) сверяет DSN в envelope со своим конфигом
    // и пересылает тело в наш же ingest — поэтому ручка не open-proxy.
    tunnel: `${config.apiUrl}/monitoring/tunnel`,

    integrations: [Sentry.browserTracingIntegration()],

    // Шум, который ничего не говорит о нашем коде: расширения браузера и
    // обрывы сети при уходе со страницы.
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      /^Failed to fetch$/,
      /^NetworkError/,
      /^AbortError/,
    ],
  })
}

/**
 * Обёртка для дерева компонентов. Экспортируется отдельно, чтобы main.tsx
 * не знал про детали SDK.
 */
export const SentryErrorBoundary = Sentry.ErrorBoundary
